import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, dark = false, testId }) => (
  <Reveal>
    <p
      className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-ivory/50" : "text-sage"}`}
      data-testid={testId ? `${testId}-eyebrow` : undefined}
    >
      {eyebrow}
    </p>
    <h2
      className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${
        dark ? "text-ivory" : "text-ink"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);
